import { c as _c } from "react/compiler-runtime";
import type { ContentfulEnvironmentOverride, SitePreviewData } from '@libs/common-next';
import css from './environment-select.module.scss';
type Option = {
  value: ContentfulEnvironmentOverride | undefined;
  label: string;
};
type Props = {
  name: keyof SitePreviewData;
  value?: SitePreviewData[keyof SitePreviewData];
  options: readonly Option[];
  onChange: (key: keyof SitePreviewData, value: ContentfulEnvironmentOverride | undefined) => void;
};
export function EnvironmentSelect(t0) {
  const $ = _c(12);
  const {
    name,
    value,
    options,
    onChange
  } = t0;
  let t1;
  if ($[0] !== name || $[1] !== onChange || $[2] !== options || $[3] !== value) {
    let t2;
    if ($[5] !== name || $[6] !== onChange || $[7] !== value) {
      t2 = option => {
        const isActive = (value ?? undefined) === option.value;
        return <button key={option.label} type="button" role="radio" aria-checked={isActive} className={`${css.option} ${isActive ? css.active : ""}`} onClick={() => onChange(name, option.value)}>{option.label}</button>;
      };
      $[5] = name;
      $[6] = onChange;
      $[7] = value;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = options.map(t2);
    $[0] = name;
    $[1] = onChange;
    $[2] = options;
    $[3] = value;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[9] !== name || $[10] !== t1) {
    t2 = <div className={css.group} role="radiogroup" aria-label={name}>{t1}</div>;
    $[9] = name;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}